import styled from "styled-components";

const InputContainer = styled.div``;

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
  marginTop: "1em",
}));

const StyledDiv = styled.div(({ theme, variant, valid, color }) => ({
  borderRadius: 21,
  backgroundColor: variant === "outlined" ? theme.color.gray10 : "transparent",

  display: "flex",
  border:
    variant === "outlined"
      ? `1px solid  ${valid === false ? "red" : color ? color : theme.color.primary
      }`
      : "none",
}));

const StyleStartImg = styled.img(({ ...props }) => ({
  marginInlineStart: "auto",
  width: 20,
  height: 20,
  alignSelf: "center",
  ...props.style,

}));

const StyleEndImg = styled.img(({ ...props }) => ({
  marginInlineStart: "auto",
  marginInlineEnd: 20,
  width: 20,
  height: 20,
  alignSelf: "center",
  ...props.style,
}));

const Input = styled("input")(({ theme, valid, variant, color }) => ({
  fontSize: 14,
  color: color ? color : theme.color.navy,
  fontWeight: 400,
  letterSpacing: 0.32,
  borderRadius: 21,
  padding: `10px 20px 10px 20px`,
  textAlign: "start",
  border: "none",
  borderBottomColor: valid === false ? theme.color.red : theme.color.primary,
  borderBottomWidth: 1,
  borderBottomStyle: variant === "outlined" ? "none" : "solid",
  width: "100%",
  backgroundColor: "transparent",
  "::placeholder": {
    color: theme.color.gray70,
  },
  "&::-webkit-outer-spin-button": {
    apearance: "none",
    margin: 0,
  },
  "&::-webkit-inner-spin-button": {
    appearance: "none",
    margin: 0,
  },
}));

const Label = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.color.label,
  fontWeight: 400,
  letterSpacing: 0.32,
  textAlign: "start",
  lineHeight: 3,
}));

const TextInput = ({
  value,
  style,
  label,
  onChange,
  placeholder,
  disabled,
  valid,
  width,
  name,
  type,
  variant,
  error,
  startImg,
  endImg,
  onEndImgClick,
  onStartImgClick,
  divStyle,
  refProp,
  helperText,
  startImgStyle,
  endImgStyle,
  ...props
}) => {
  const onUpdate = (e) => {
    onChange(e);
  };

  return (
    <InputContainer>
      {!!label && <Label>{label}</Label>}
      <StyledDiv
        variant={variant}
        valid={valid}
        style={{
          ...divStyle,
          // an explicit error wins over any divStyle border
          ...(valid === false ? { border: "1px solid red" } : {}),
        }}
      >
        {!!startImg &&
          <StyleStartImg style={startImgStyle}
            src={startImg}
            alt="input-start-img"
            onClick={(e) => onStartImgClick(e)} />
        }
        <Input
          ref={refProp}
          disabled={disabled}
          placeholder={placeholder}
          type={type || "text"}
          value={value}
          onChange={onUpdate}
          name={name}
          variant={variant}
          valid={valid}
          {...props}
        />
        {!!endImg && (
          <StyleEndImg
            style={endImgStyle}
            src={endImg}
            alt="input-end-img"
            onClick={(e) => onEndImgClick(e)}
          />
        )}
      </StyledDiv>
      {!!helperText && <Error>{helperText}</Error>}
    </InputContainer>
  );
};

export default TextInput;
